import { useState } from 'react';

const features = [
  {
    title: 'Automação de Documentos',
    description: 'Geração automática de contratos e procurações, garantindo agilidade, padronização e profissionalismo.',
    icon: 'ri-file-text-line',
    gradient: 'from-yellow-400 to-orange-500',
  },
  {
    title: 'Rastreamento em Tempo Real',
    description: 'Acompanhamento de infrações de veículos avulsos ou frotas inteiras com relatórios detalhados e atualizações instantâneas.',
    icon: 'ri-map-pin-line',
    gradient: 'from-green-400 to-emerald-500',
  },
  {
    title: 'Editais Enriquecidos',
    description: 'Acesso a editais públicos de infrações já enriquecidos com contatos dos infratores para prospecção ativa em escala.',
    icon: 'ri-file-list-3-line',
    gradient: 'from-amber-400 to-yellow-500',
  },
  {
    title: 'Marketing Integrado',
    description: 'Produção de posts para redes sociais e suporte de marca para fortalecer a presença digital dos parceiros.',
    icon: 'ri-megaphone-line',
    gradient: 'from-orange-400 to-red-500',
  },
];

export default function FeaturesSection() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="funcionalidades" className="py-20 md:py-32 relative bg-gray-900 overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(251,191,36,0.05),transparent_70%)] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16 md:mb-24 scroll-animate">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-500/10 rounded-full mb-6 border border-yellow-500/20 backdrop-blur-sm">
            <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
            <span className="text-sm font-semibold text-yellow-500">POR QUE ESCOLHER A CENTRAL DA MULTA?</span>
          </span>
          <h2 className="text-3xl md:text-6xl font-bold text-white mb-6">
            Recursos <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500">Poderosos</span> para seu Negócio
          </h2>
          <p className="text-lg md:text-2xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Desenvolvemos as melhores ferramentas para você automatizar processos e focar no que realmente importa: vender mais e atender melhor seus clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="group relative bg-gray-800/40 backdrop-blur-xl rounded-3xl p-8 border border-gray-700/50 hover:border-yellow-500/30 transition-all duration-500 scroll-animate hover:-translate-y-2 hover:shadow-2xl hover:shadow-yellow-500/10"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-3xl"></div>

              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-8 shadow-lg shadow-yellow-500/20 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-500 relative overflow-hidden`}>
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/30 to-transparent"></div>
                <i className={`${feature.icon} text-white text-3xl relative z-10`}></i>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-yellow-400 transition-colors duration-300">
                {feature.title}
              </h3>

              <p className="text-gray-400 text-lg leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                {feature.description}
              </p>

              <div className={`mt-8 flex items-center gap-2 text-yellow-500/0 group-hover:text-yellow-500/100 transition-all duration-500 ${hoveredIndex === index ? 'translate-x-2' : ''}`}>
                <span className="text-sm font-semibold uppercase tracking-wider">Conhecer mais</span>
                <i className="ri-arrow-right-line"></i>
              </div>

              {/* Animated corner accent */}
              <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-yellow-500/0 rounded-tr-3xl group-hover:border-yellow-500/20 transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
